import { render } from "./BattleResultList.vue?vue&type=template&id=3e66dd04&scoped=true"
import script from "./BattleResultList.vue?vue&type=script&lang=js"
export * from "./BattleResultList.vue?vue&type=script&lang=js"

import "./BattleResultList.vue?vue&type=style&index=0&id=3e66dd04&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e66dd04"]])

export default __exports__